module.exports = __webpack_public_path__ + "static/media/sitemap.cc59e782.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/amenities/sitemap.jpg
// module id = 167
// module chunks = 0